<template>
  <div>
    <div class="right_menu">
      <div class="web">
        <button v-on:click="getCudaStatus">测试按钮</button>
        <button v-on:click="changeCudaStatus">改变状态</button>
        <!-- <iframe src="http://8.155.53.4:6081" frameborder="0"></iframe> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import Cuda from '@/utils/checkCuda'
export default {
  name: 'ComfyUI',
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    matting() {
      this.$router.push({
        path: '/cropimage'
      })
    },
    flux_image() {
      this.$router.push({
        path: '/index/generate'
      })
    },
    wan_vedio() {
      alert('正在开发中,敬请期待!')
    },
    warning() {
      Message.success('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    async getCudaStatus() {
      try {
        const res = await Cuda.cudaCurrentStatus()
        for (const key in res) {
          if (res[key]['status'] === 'leisure') {
            console.log('当前cuda可用', key)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async changeCudaStatus() {
      try {
        const res = await Cuda.changeCudaCurrentStatus('cuda0', 'leisure')
        for (const key in res) {
          console.log(key, res[key]['status'])
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.right_menu {
  width: calc(100vw - 360px);
  height: calc(100vh - 80px);
  padding: 30px 30px;
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .web {
    width: calc(100vw - 420px);
    height: calc(100vh - 160px);
    border: 1px solid @basicselect;
    border-radius: 25px;
    overflow: hidden;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);

    iframe {
      width: 100%;
      height: 100%;
      border-radius: 25px;
    }
  }

  button {
    width: 200px;
    height: 80px;
  }
}
</style>
